var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-4 ml-auto mr-auto text-center"},[_c('div',{staticClass:"game-icon"},[_c('img',{staticStyle:{"width":"80%","margin-bottom":"32px","box-shadow":"rgba(86, 86, 86, 0.56) 0px 9px 20px 3px"},attrs:{"src":_vm.icon}})]),_vm._v(" "),_c('h1',[_vm._v("COMING SOON!")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2bde24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Landing.vue
// module id = null
// module chunks = 